import { useMutation, useQueryClient } from 'react-query'
import { API_METHODS } from 'constants/api-methods'
import { BASE_API_URL } from 'constants/env'
import { ID } from 'utils/types'
import { store } from 'index'
import { apiHeaders } from 'utils/api-headers'
import { UserOrganization } from 'interfaces/user-organization'
import { handleErrorsAndJSON } from 'utils/handle-errors'
import { userOrganizationsKeys } from 'utils/query-keys'
import toast from 'react-hot-toast'

const useDeleteUserOrganization = (orgId: ID) => {
  const queryClient = useQueryClient()

  const deleteUserOrganization = async (userOrg?: UserOrganization) => {
    const response = await fetch(
      `${BASE_API_URL}/api/v3/organizations/${orgId}/user_organizations/${userOrg?.id}`,
      {
        method: API_METHODS.DELETE,
        headers: apiHeaders(store.getState()),
      }
    )
    return handleErrorsAndJSON(response)
  }

  return useMutation(
    ({ userOrg }: { userOrg?: UserOrganization }) =>
      deleteUserOrganization(userOrg),
    {
      onSettled: () => {
        queryClient
          .invalidateQueries(userOrganizationsKeys.detail(orgId))
          .catch(console.error)
      },
      onError: (error: any, variables, context) => {
        console.error('Delete user organization error:', error)

        // Check if the error is related to active Texting Betty integration
        if (
          error?.error?.type === 'texting_betty_integration_active' ||
          error?.message?.includes('Texting Betty') ||
          error?.error?.messages?.some((msg: string) =>
            msg.includes('Texting Betty')
          )
        ) {
          toast.error(
            error.message ||
              error?.error?.messages?.[0] ||
              'User has active Texting Betty integration. Delete it first.',
            {
              duration: 5000,
              icon: '⚠️',
            }
          )
        } else {
          // Generic error handling
          toast.error(
            error.message || 'Failed to remove user. Please try again.',
            {
              duration: 4000,
              icon: '❌',
            }
          )
        }
      },
    }
  )
}

export default useDeleteUserOrganization
